import request from './request.js'
import Servers from '@config'

export default {
  // 获取登录用户信息
  fetchUserInfo: request.get(Servers.oss + '/mall/user/info'),

  // 获取用户购买版本信息
  fetchPlanVersion: request.get(Servers.crm + '/api/pageRead/getMainSystemId'),

  // 获取地址列表
  fetchAreaList: request.get(Servers.oss + '/siteapi/common-api/area'),

  // 获取图形验证码
  fetchImageCodeUrl: request.get(
    Servers.oss + '/siteapi/common-api/get-image-verify-code'
  ),

  // 提交企业认证
  saveClinetVerification: request.post(
    Servers.oss + '/customer/client-verification/save'
  ),

  // 查询企业认证状态
  fetchClientVerifyInfo: request.get(Servers.oss + '/mall/client/verification'),

  // 发送企业认证验证码
  fetchVerifySmsCode: request.post(
    Servers.oss + '/customer/client-verification/send-sms-code'
  ),

  // 验证同样信用码
  verifyCreditCode: request.get(
    Servers.oss + '/customer/client-verification/search'
  ),

  // 设置用户语言
  saveUserSetting: request.post(Servers.crm + '/api/UserWrite/saveUserSetting'),

  // 获取法大大认证状态
  fetchFadadaVerifyInfo: request.get(Servers.oss + '/mall/user/fadada-status'),

  // 获取Client对应的阿里账号列表
  fetchGIDMemberIDList: request.get(Servers.oss + '/mall/order/get-gid-member'),
}
